import { createEventBusModule } from 'hooks/eventBus';
import { createApiModule } from 'hooks/fetch';
const MODULE_NAME = 'Payment';
const createApiModuleActions = createApiModule(MODULE_NAME);
const createEventBusModuleEvent = createEventBusModule(MODULE_NAME);
// Reducers
const PENDING_PAYMENTS = 'pendingPayments';
const THANKED_PAYMENT = 'thankedPayment';
const REMINDED_REQUEST = 'remindedRequest';
const reducers = {
    PENDING_PAYMENTS,
    THANKED_PAYMENT,
    REMINDED_REQUEST,
};
// Api actions
const completedPayments = createApiModuleActions('COMPLETED_PAYMENTS');
const pendingPayments = createApiModuleActions('PENDING_PAYMENTS');
const paymentLink = createApiModuleActions('PAYMENT_LINK');
const paymentLinksByNamesAndHandles = createApiModuleActions('PAYMENT_LINKS_BY_NAMES_AND_HANDLES');
const updateBillSharingForTransaction = createApiModuleActions('UPDATE_BILL_SHARING_FOR_TRANSACTION');
const deleteBillSharingForTransaction = createApiModuleActions('DELETE_BILL_SHARING_FOR_TRANSACTION');
const paymentSend = createApiModuleActions('PAYMENT_SEND');
const topUpGIAAccountFromBankAccount = createApiModuleActions('TOPUP_GIA_ACCOUNT_FROM_BANK_ACCOUNT');
const topUpSecclAccountFromBankAccountUsingDirectDebit = createApiModuleActions('TOPUP_SECCL_ACCOUNT_FROM_BANK_ACCOUNT_USING_DIRECT_DEBIT');
const buySecclAssetFromConnectedAccount = createApiModuleActions('BUY_SECCL_ASSET_FROM_BANK_ACCOUNT');
const depositToPotFromBankAccountOrConnectedAccount = createApiModuleActions('DEPOSIT_TO_POT_FROM_BANK_ACCOUNT_OR_CONNECTED_ACCOUNT');
const paymentInfo = createApiModuleActions('PAYMENT_INFO');
const paymentRequestInfo = createApiModuleActions('PAYMENT_REQUEST_INFO');
const paymentDefaultAccount = createApiModuleActions('PAYMENT_DEFAULT_ACCOUNT');
const paymentRequestFulfill = createApiModuleActions('PAYMENT_REQUEST_FULFILL');
const paymentRequestCancel = createApiModuleActions('PAYMENT_REQUEST_CANCEL');
const paymentSendThanks = createApiModuleActions('PAYMENT_SEND_THANKS');
const paymentRequestRemind = createApiModuleActions('PAYMENT_REQUEST_REMIND');
const handleInfo = createApiModuleActions('HANDLE_INFO');
const apiEvents = {
    completedPayments,
    pendingPayments,
    paymentLink,
    paymentLinksByNamesAndHandles,
    updateBillSharingForTransaction,
    deleteBillSharingForTransaction,
    paymentSend,
    paymentInfo,
    paymentRequestInfo,
    paymentDefaultAccount,
    paymentRequestFulfill,
    paymentRequestCancel,
    paymentSendThanks,
    paymentRequestRemind,
    handleInfo,
    topUpGIAAccountFromBankAccount,
    topUpSecclAccountFromBankAccountUsingDirectDebit,
    buySecclAssetFromConnectedAccount,
    depositToPotFromBankAccountOrConnectedAccount,
};
// Bus events
const PAYMENT_SENT = createEventBusModuleEvent('PAYMENT_SENT');
const REQUEST_CREATED = createEventBusModuleEvent('REQUEST_CREATED');
const REQUEST_FULFILLED = createEventBusModuleEvent('REQUEST_FULFILLED');
const REQUEST_CANCELED = createEventBusModuleEvent('REQUEST_CANCELED');
const REQUEST_REJECTED = createEventBusModuleEvent('REQUEST_REJECTED');
const busEvents = {
    PAYMENT_SENT,
    REQUEST_CREATED,
    REQUEST_FULFILLED,
    REQUEST_CANCELED,
    REQUEST_REJECTED,
};
export { apiEvents, busEvents, reducers };
export default { apiEvents, busEvents, reducers };
